<template>
  <div>
    <div class="content-box content-box-plus child" v-if="!measuresQuantity || measuresQuantity === 0">
      <div class="row px-4">
        <header>
          <h2 class="mt-3 title">
            <span class="egx-partner-color">
              {{ fulfillSyncDetails.pages?.projects_measure_list?.not_selected_measures?.title }}
            </span>
          </h2>
          <p class="sub-title">
            {{ fulfillSyncDetails.pages?.projects_measure_list?.not_selected_measures?.text }}
          </p>
        </header>
      </div>
    </div>
    <div v-for="(groupedMeasure, index) in groupedMeasures" :key="groupedMeasure.id" v-else>
      <div class="my-3 pl-4 content-box content-box-plus child overflow-visible">
        <div class="mb-2 ">
          <div class="title">
            {{ groupedMeasure.name }}
          </div>
          <div class="description" v-safe-html="groupedMeasure.measure_instruction" />
        </div>
        <div class="container p-0 py-2">
          <div class="incentives-list">
            <div class="mr-2" v-for="(retrofit, index) in groupedMeasure.retrofits" :key="retrofit.pm_id">
              <div class="retrofit-section form">
                <hr v-show="index !== 0" />
                <div class="d-flex row">
                  <div class="d-grid pr-4 col-md-5 col-sm-12 pb-2 d-flex align-items-center">
                    <div class="mb-0 pl-0">
                      <div class="sub-title mb-0 btn p-0" @click="selectMeasure(retrofit)">{{ retrofit.name }}</div>
                      <div class="mb-0 field-label">
                        <div>{{ retrofit.hierarchy_level_1 }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center col-md-3">
                    <span class="mr-2 btn" @click="togglePopup(retrofit.pm_id, 'measureDetails')">
                      <font-awesome-icon
                        :icon="['fa', 'info-circle']"
                        class="fa-lg egx-partner-color"
                        data-toggle="tooltip"
                        :title="fulfillSyncDetails.pages?.projects_measure_list?.tooltips?.measure_details"
                        ref="tooltip"
                      />
                    </span>
                    <span class="btn" @click="togglePopup(retrofit.pm_id)">
                      <font-awesome-icon
                        :icon="['fa', 'list-alt']"
                        class="fa-lg egx-partner-color"
                        data-toggle="tooltip"
                        :title="fulfillSyncDetails.pages?.projects_measure_list?.tooltips?.measure_info"
                        ref="tooltip"
                      />
                    </span>
                    <PopupBubble
                      v-if="popupVisible[retrofit.pm_id]"
                      :selectedRetrofit="retrofit"
                      :retrofitId="retrofit.pm_id"
                      :measureTypeName="popupType[retrofit.pm_id] === 'measureDetails' ? 'measureDetails' : retrofit.type"
                      :project-id="projectId"
                      :onClose="() => togglePopup(retrofit.pm_id)"
                      :getMeasureDetails="getMeasureDetails"
                      :measureDetails="measureDetails[retrofit.id]"
                    />
                  </div>
                  <div class="d-flex align-items-center pr-4 col-md-4 pb-2 text-center justify-content-between">
                    <div
                      class="d-flex flex-column justify-content-center text-center"
                      style="min-width: 6rem; width: 6rem;"
                    >
                      <small style="color: grey; white-space: nowrap;">Quantity</small>
                      <input
                        type="number"
                        class="form-control field-label mx-auto"
                        placeholder="0"
                        v-model="retrofit.quantity"
                        style="width: 6.5rem; height: 2rem; margin: 0.2rem 0;"
                        min="0"
                        @change="validateQuantity(retrofit)"
                        @keydown="blockInvalidChars"
                      />
                      <small style="color: grey; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">{{ retrofit.units_qty }}</small>
                    </div>
                    <div>
                      <span class="mr-4 btn" @click="openDialog(retrofit)">
                        <font-awesome-icon
                          :icon="['fa', 'trash-alt']"
                          class="fa-lg egx-partner-color"
                          data-toggle="tooltip"
                          :title="fulfillSyncDetails.pages?.projects_measure_list?.tooltips?.delete"
                          ref="tooltip"
                        />
                      </span>
                      <span class="btn" @click="duplicateMeasure(retrofit)">
                        <font-awesome-icon
                          :icon="['fa', 'copy']"
                          class="fa-lg egx-partner-color"
                          data-toggle="tooltip"
                          :title="fulfillSyncDetails.pages?.projects_measure_list?.tooltips?.copy"
                          ref="tooltip"
                        />
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccordionTabList from '@/components/project/AccordionTabList.vue';
import PopupBubble from '@/components/project/PopupBubble.vue';
import FieldHelper from '@/shared/mixins/field-helper';

export default {
  components: {
    AccordionTabList,
    PopupBubble,
  },
  mixins: [ FieldHelper ],
  props: {
    groupedMeasures: Array,
    fulfillSyncDetails: Object,
    projectId: String,
    popupVisible: Object,
    popupType: Object,
    quantities: Object,
    measureDetails: String,
  },
  data() {
    return {
      measuresQuantity: this.groupedMeasures.length,
    };
  },
  watch: {
    groupedMeasures: {
      immediate: true,
      handler(newVal) {
        this.measuresQuantity = newVal.length;
      },
    },
  },
  methods: {
    selectMeasure(measure) {
      this.$emit('select-measure', measure);
    },
    togglePopup(retrofitId, type) {
      this.$emit('toggle-popup', retrofitId, type);
    },
    getMeasureDetails(retrofitId) {
      this.$emit('get-measure-details', retrofitId);
    },
    openDialog(retrofit) {
      this.$emit('open-dialog', retrofit);
    },
    duplicateMeasure(measure) {
      this.$emit('duplicate-measure', measure);
    },
    validateQuantity(retrofit) {
      if (isNaN(retrofit.quantity) || retrofit.quantity < 0) {
        retrofit.quantity = 0;
      }
    },
  },
};
</script>
